import { useTranslation } from 'next-i18next'
import { useEffect, useState } from 'react'
import { useCookie } from 'react-use'

interface CountdownTimerProps {
  endDate: Date
  setStop: (stop: boolean) => void
  className?: string
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({ endDate, setStop, className }) => {
  const { t } = useTranslation('limited-sale-time')
  const [days, setDays] = useState(0)
  const [hours, setHours] = useState('00')
  const [minutes, setMinutes] = useState('00')
  const [seconds, setSeconds] = useState('00')
  const [, removeCampaignEndTime] = useCookie('_ltst')

  useEffect(() => {
    const target = new Date(endDate)

    if (!isNaN(target.getDate())) {
      const interval = setInterval(() => {
        const now = new Date()
        const difference = target.getTime() - now.getTime()

        const d = Math.floor(difference / (1000 * 60 * 60 * 24))
        setDays(d)

        const h = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        setHours(String(h).padStart(2, '0'))

        const m = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))
        setMinutes(String(m).padStart(2, '0'))

        const s = Math.floor((difference % (1000 * 60)) / 1000)
        setSeconds(String(s).padStart(2, '0'))

        if (d <= 0 && h <= 0 && m <= 0 && s <= 0) {
          setStop(true)
          removeCampaignEndTime('')
        }
      }, 1000)

      return () => clearInterval(interval)
    }
  }, [])

  return (
    <>
      <div className={className}>
        {days ? (
          <>
            {days}&nbsp;{t('days')}
          </>
        ) : (
          <>
            {hours} : {minutes} : {seconds}
          </>
        )}
      </div>
    </>
  )
}

export default CountdownTimer
